// extracted by mini-css-extract-plugin
export var infoRow = "_s3-2";
export var labelContainer = "_s3-0";
export var rightInfo = "_s3-1";